import { FC } from 'react';
import clsx from 'clsx';
import { ILabel } from '../../../types';
import styles from './styles.module.css';

const Label: FC<ILabel> = props => {
  const { required = false, children, ...rest } = props;

  return (
    <label className={clsx('label', styles.label)} {...rest}>
      {children}
      {required && <span className={styles.required}>*</span>}
    </label>
  );
};

export default Label;
